<template>
    <Link
        :href="url"
        class="
            p-button p-button-sm
            border-blue-700
            bg-blue-700
            hover:bg-[#4338CA]
        "
    >
        <slot></slot>
    </Link>
</template>
<script>
import { defineComponent } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

export default defineComponent({
    components: {
        Link,
    },
    props: ["url"],
});
</script>